import { NetworkGatewayType } from 'decentraland-ui/dist/components/BuyManaWithFiatModal/Network';
import { BaseAPI } from '../../../lib/api';
import { PurchaseStatus } from '../types';
import { MoonPayTransactionStatus } from './types';
export class MoonPay {
    apiKey;
    widgetBaseUrl;
    moonPayAPI;
    constructor(config) {
        const { apiKey, apiBaseUrl, widgetBaseUrl } = config;
        this.apiKey = apiKey;
        this.widgetBaseUrl = widgetBaseUrl;
        this.moonPayAPI = new BaseAPI(apiBaseUrl);
    }
    getPurchaseStatus(status) {
        return {
            [MoonPayTransactionStatus.WAITING_PAYMENT]: PurchaseStatus.PENDING,
            [MoonPayTransactionStatus.PENDING]: PurchaseStatus.PENDING,
            [MoonPayTransactionStatus.WAITING_AUTHORIZATION]: PurchaseStatus.PENDING,
            [MoonPayTransactionStatus.FAILED]: PurchaseStatus.FAILED,
            [MoonPayTransactionStatus.COMPLETED]: PurchaseStatus.COMPLETE
        }[status];
    }
    /**
     * Given the transaction id, returns the MoonPay Transaction.
     *
     * @param transactionId - MoonPay Transaction ID.
     */
    async getTransaction(transactionId) {
        return await this.moonPayAPI.request('GET', `/v1/transactions/${transactionId}`, { apiKey: this.apiKey });
    }
    /**
     * Given the transaction, returns a Promise of an object with the relevant information of the purchase.
     *
     * @param transaction - MoonPay Transaction.
     */
    createPurchase(transaction, network) {
        const { id, quoteCurrencyAmount, createdAt, status, walletAddress, cryptoTransactionId, paymentMethod } = transaction;
        return {
            id,
            amount: quoteCurrencyAmount,
            network,
            timestamp: +new Date(createdAt),
            status: this.getPurchaseStatus(status),
            paymentMethod,
            address: walletAddress,
            gateway: NetworkGatewayType.MOON_PAY,
            txHash: cryptoTransactionId
        };
    }
    getWidgetUrl(network) {
        const redirectURL = `${window.location.origin}?network=${network}&gateway=${NetworkGatewayType.MOON_PAY}`;
        return `${this.widgetBaseUrl}?apiKey=${this.apiKey}&currencyCode=MANA&redirectURL=${encodeURIComponent(redirectURL)}`;
    }
    getTransactionReceiptUrl(transactionId) {
        return `${this.widgetBaseUrl}/transaction_receipt?transactionId=${transactionId}`;
    }
}
//# sourceMappingURL=MoonPay.js.map